import React from 'react';
import cx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import loadable from '@loadable/component';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import Collapse from '@material-ui/core/Collapse';
import ListSubheader from '@material-ui/core/ListSubheader';

import { NotMobile, Mobile } from '../MediaQuery';
import NestedDropdown from '../NestedDropdown';
import Link from '../Link';
import productsQueryWithoutImage from '../../query/productsQueryWithoutImage';
import {
    genCategoryUrl, aboutUrl, contactUrl, allCategoriesUri,
} from '../../utils/urls';
import * as moduleStyles from './style.module.scss';
import * as themeStyles from '../../assets/theme.module.scss';
import { sendEvent } from '../../utils/ga';

const SearchModal = loadable(() => import('../SearchModal'));

const MobileMenu = ({ categories, handleCloseDrawer }) => {
    const [isProductCollapseOpen, setOpen] = React.useState(false);

    function handleClickProductCollapse() {
        setOpen(!isProductCollapseOpen);
    }

    const items = categories.map((category) => {
        const { name, url } = category;
        return (
            <ListItem key={url} component={Link} to={genCategoryUrl(url)} style={{ paddingLeft: '40px' }}>
                <ListItemText primary={name} />
            </ListItem>
        );
    });
    return (
        <>
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={moduleStyles.mobileListWrapper}
                subheader={(
                    <ListSubheader component="div" id="nested-list-subheader">
                        <div className={themeStyles.row} style={{ backgroundColor: 'white' }}>
                            <div className={cx(themeStyles.col, themeStyles.col9)}>
                                建臺有限公司
                            </div>
                            <div className={cx(themeStyles.col, themeStyles.col1)}>
                                <CloseIcon onClick={handleCloseDrawer} />
                            </div>
                        </div>
                    </ListSubheader>
                )}
            >
                <ListItem button onClick={handleClickProductCollapse}>
                    <ListItemText primary="產品介紹" />
                    {isProductCollapseOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={isProductCollapseOpen} unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem component={Link} to={allCategoriesUri} style={{ paddingLeft: '40px' }}>
                            <ListItemText primary="所有產品" />
                        </ListItem>
                        {items}
                    </List>
                </Collapse>
                <ListItem component={Link} to={aboutUrl}>
                    <ListItemText>
                        關於我們
                    </ListItemText>
                </ListItem>
                <ListItem component={Link} to={contactUrl}>
                    <ListItemText>
                        聯絡我們
                    </ListItemText>
                </ListItem>
            </List>
        </>
    );
};

const Navbar = ({ isMobileDrawerOpen, handleCloseDrawer }) => {
    const categories = productsQueryWithoutImage();
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const isSSR = typeof window === 'undefined';

    function openModal() {
        document.body.style.overflow = 'hidden';
        document.getElementsByTagName('html')[0].style.overflow = 'hidden';
        sendEvent('Search Input', 'click', 'open');
        setIsOpen(true);
    }

    function closeModal() {
        document.body.style.overflow = 'unset';
        document.getElementsByTagName('html')[0].style.overflow = '';
        setIsOpen(false);
    }

    return (
        <>
            <NotMobile>
                <div className={cx(themeStyles.container, themeStyles.py2, themeStyles.dNone, themeStyles.dMdFlex, themeStyles.alignItemsCenter)}>
                    <ul className={cx(themeStyles.nav, themeStyles.mrAuto, moduleStyles.subNavbar)}>
                        <li className={themeStyles.navItem}>
                            {/* <Link className={cx(themeStyles.navLink, themeStyles.pl0, themeStyles.active)} to={allCategoriesUri}>
                                產品介紹
                            </Link> */}
                            <NestedDropdown className={cx(themeStyles.navLink, themeStyles.pl0)} categories={categories} />
                        </li>
                        <li className={themeStyles.navItem}>
                            <Link className={themeStyles.navLink} to={aboutUrl}>
                                關於我們
                            </Link>
                        </li>
                        <li className={themeStyles.navItem}>
                            <Link className={themeStyles.navLink} to={contactUrl}>
                                聯絡我們
                            </Link>
                        </li>
                    </ul>
                    <div className={moduleStyles.searchInput}>
                        <input onClick={openModal} type="text" placeholder="查詢產品" aria-label="查詢產品" aria-describedby="button-addon2" />
                    </div>
                </div>
                {!isSSR
                    ? (
                        <SearchModal modalIsOpen={modalIsOpen} closeModal={closeModal} />
                    )
                    : null}
            </NotMobile>
            <Mobile>
                <Drawer open={isMobileDrawerOpen} onClose={handleCloseDrawer} anchor="right">
                    <MobileMenu categories={categories} handleCloseDrawer={handleCloseDrawer} />
                </Drawer>
            </Mobile>
        </>
    );
};

export default Navbar;
